import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

// Styles
import "./Gallery.scss"

const Gallery = () => {
  const imgGallery = useStaticQuery(graphql`
    query {
      gallery: allFile(
        filter: {
          extension: { regex: "/(jpeg|jpg|gif|png)/" }
          sourceInstanceName: { eq: "image-gallery" }
        }
      ) {
        edges {
          node {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `)

  return (
    <div className="gallery-container">
      {imgGallery.gallery.edges.map((item, i) => (
        <Img key={i} fluid={item.node.childImageSharp.fluid} />
      ))}
    </div>
  )
}

export default Gallery
